import { User, Users } from "lucide-react";

import { CargosField } from "@/pages/admin/aprovacoes/components/CargosField";
import type { NotificacaoTesteDestinatario } from "@/services/api/notificacao-teste.service";

interface DestinatariosInboxFieldProps {
  pessoas: NotificacaoTesteDestinatario[];
  carregando: boolean;
  /** Identidades escolhidas — é assim que o Inbox endereça a pessoa. */
  value: string[];
  onChange: (identityIds: string[]) => void;
}

/**
 * No INBOX não dá para digitar o destino: o chat interno endereça por `identityId`,
 * então a escolha sai de uma lista de quem tem identidade vinculada no Identity.
 */
export function DestinatariosInboxField({
  pessoas,
  carregando,
  value,
  onChange,
}: DestinatariosInboxFieldProps) {
  const options = pessoas.map((p) => ({ value: p.identityId, label: p.nome }));
  const nomePorIdentity = new Map(pessoas.map((p) => [p.identityId, p.nome]));

  return (
    <CargosField
      value={value}
      onChange={onChange}
      options={options}
      labelResolver={(identityId) => nomePorIdentity.get(identityId) ?? identityId}
      title="Destinatários"
      icon={<Users className="size-3.5" />}
      itemIcon={<User className="size-4" />}
      searchPlaceholder="Buscar pessoa..."
      emptyTitle={carregando ? "Carregando pessoas..." : "Nenhum destinatário ainda"}
      emptyDescription="Só pessoas com identidade vinculada no Identity aparecem aqui."
    />
  );
}
